"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUsageTracker = setUsageTracker;
exports.getUsageTracker = getUsageTracker;
exports.trackEvent = trackEvent;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var Tracker;

function setUsageTracker(usageTracker) {
  if (!Tracker) {
    Tracker = usageTracker;
  }
}

function getUsageTracker() {
  return Tracker || {};
}

function trackEvent(eventData) {
  if (!Tracker) {
    return;
  }

  var name = eventData.name,
      action = eventData.action,
      _eventData$extra = eventData.extra,
      extra = _eventData$extra === void 0 ? {} : _eventData$extra,
      otherFields = (0, _objectWithoutProperties2.default)(eventData, ["name", "action", "extra"]);
  var eventPayload = Object.assign({
    action: action
  }, otherFields, {}, extra);
  Tracker.track(name, eventPayload);
}